export default function secondsToHms(d) {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor(d % 3600 / 60);
    var s = Math.floor(d % 3600 % 60);

    // var hDisplay = h > 0 ? h + (h == 1 ? " hour, " : " hours, ") : "";
    // var mDisplay = m > 0 ? m + (m == 1 ? " minute, " : " minutes, ") : "";
    // var sDisplay = s > 0 ? s + (s == 1 ? " second" : " seconds") : "";
    var hDisplay = h > 0 ? h + (h == 1 ? "hr" : "hrs") : "";
    if (h > 0) return hDisplay;
    var mDisplay = m > 0 ? m + (m == 1 ? "min" : "mins") : "";
    if (m > 0) return mDisplay;
    var sDisplay = s > 0 ? s + (s == 1 ? "sec" : "secs") : "";
    if (s > 0) return sDisplay; else return "0sec"
}